import React, { useState, useEffect } from 'react'
import Navbar from '../nav/Navbar'
import Footer from '../footer/Footer'

function Schedule_of_charges() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Detect dark mode preference
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: isDarkMode ? '#e0e0e0' : '#333',
      backgroundColor: isDarkMode ? '#1a1a1a' : 'transparent',
      minHeight: '100vh'
    },
    header: {
      textAlign: 'center',
      color: isDarkMode ? '#ffffff' : '#2c3e50',
      padding: '40px 20px',
      backgroundColor: isDarkMode ? '#2d2d2d' : '#f8f9fa',
      marginBottom: '0'
    },
    content: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px'
    },
    section: {
      marginTop: '3rem',
      backgroundColor: isDarkMode ? '#2d2d2d' : '#ffffff',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: isDarkMode ? '0 2px 10px rgba(0,0,0,0.3)' : '0 2px 10px rgba(0,0,0,0.1)'
    },
    sectionTitle: {
      color: isDarkMode ? '#ffffff' : '#2c3e50',
      textAlign: 'center',
      marginBottom: '10px',
      borderBottom: `2px solid ${isDarkMode ? '#4a90e2' : '#3498db'}`,
      paddingBottom: '10px'
    },
    version: {
      textAlign: 'center',
      color: isDarkMode ? '#b0b0b0' : '#666',
      fontStyle: 'italic',
      marginBottom: '30px',
      fontSize: '14px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      margin: '20px 0',
      fontSize: '14px',
      backgroundColor: isDarkMode ? '#2d2d2d' : '#ffffff',
      border: `1px solid ${isDarkMode ? '#555' : '#ddd'}`
    },
    tableHeader: {
      backgroundColor: isDarkMode ? '#3d3d3d' : '#34495e',
      color: isDarkMode ? '#ffffff' : 'white',
      padding: '15px',
      textAlign: 'center',
      border: `1px solid ${isDarkMode ? '#555' : '#ddd'}`,
      fontWeight: 'bold'
    },
    tableCell: {
      padding: '12px 15px',
      border: `1px solid ${isDarkMode ? '#555' : '#ddd'}`,
      verticalAlign: 'top',
      backgroundColor: isDarkMode ? '#2d2d2d' : '#ffffff',
      color: isDarkMode ? '#e0e0e0' : '#333'
    },
    tableRow: {
      transition: 'background-color 0.2s ease'
    },
    tableRowHover: {
      backgroundColor: isDarkMode ? '#3a3a3a' : '#f5f5f5'
    },
    disclaimer: {
      backgroundColor: isDarkMode ? '#3d3d3d' : '#fff3cd',
      padding: '20px',
      borderRadius: '6px',
      marginTop: '30px',
      border: `1px solid ${isDarkMode ? '#555' : '#ffeaa7'}`,
      color: isDarkMode ? '#e0e0e0' : '#856404',
      fontSize: '14px',
      lineHeight: '1.5'
    },
    strong: {
      color: isDarkMode ? '#ffffff' : 'inherit',
      fontWeight: 'bold'
    }
  };

  const [hoveredRow, setHoveredRow] = useState(null);

  // Table data from the PDF
  const tableData = [
    { id: 1, name: "Loan Processing Charges/Review Fees*", amount: "Upto 3% of Loan Amount" },
    { id: 2, name: "ROI", amount: "Upto 36% Per Annum" },
    { id: 3, name: "Stamp Duty", amount: "As Per The State's Stamp Act" },
    { id: 4, name: "Stamping Admin Charges**", amount: "₹ 200" },
    { id: 5, name: "Penal Charges*", amount: "Up to 3% p.m. On the instalment overdue from the due date up to the date of Payment" },
    { id: 6, name: "Part-Prepayment**", amount: "10% prepayment fee for partial/full prepayment. No partial prepayment allowed in loans less than 12 MOB. Partial prepayments allowed only 2 times in a year. There should be a minimum gap of 4 months between two partial prepayments." },
    { id: 7, name: "Foreclosure Charges*", amount: "10% of Outstanding Principal" },
    { id: 8, name: "Cash Collection Charges (If Cash Deposited for Foreclosure / Prepayment / Repayment / Any other charges)*", amount: "₹ Upto 5% of deposit amount" },
    { id: 9, name: "Collection Visit Charges*", amount: "₹ 500 Per Visit" },
    { id: 10, name: "Cheque/NACH Return Charges*", amount: "₹ 1,000" },
    { id: 11, name: "Cheque/Disbursement/Loan Cancellation*", amount: "1. During the Cooling Period of 7 Days From Date of Disbursal There is No Cancellation Charges & Interest Will be Charged as Per APR of The Respective Case.<br/>2. Post Cooling of Period ₹ 1000 Plus Applicable Interest up to Cancellation Period Will be Charged Subject to Funds Not Used by Customer" },
    { id: 12, name: "Statement of Account Charges*", amount: "₹ 1,000" },
    { id: 13, name: "Duplicate Amortisation/Repayment Schedule Charges*", amount: "₹ 1,000" },
    { id: 14, name: "Duplicate Copy of Property Paper/Loan Document Charges*", amount: "₹ 1,000" },
    { id: 15, name: "Provisional/ Final Interest Certificate*", amount: "₹ 1,000" },
    { id: 16, name: "List of Documents (LOD)*", amount: "₹ 1,000" },
    { id: 17, name: "Issue of Duplicate NOC*", amount: "₹ 1000 Per Instance" },
    { id: 18, name: "Swap Charges (Replacement of PDC/Change of Account)*", amount: "₹ 1,000" },
    { id: 19, name: "Foreclosure Statement Charges*", amount: "₹ 1000 Per Instance" },
    { id: 20, name: "Legal/ Sarfleast/Incidental Charges*", amount: "At Actuals" },
    { id: 21, name: "Tele Collection Charges*", amount: "₹ 100 Per Instance" },
    { id: 22, name: "Property Valuation Charges*", amount: "Upto ₹ 5000 Per Property" },
    { id: 23, name: "Property Legal Charges*", amount: "Upto ₹ 5000 Per Property" },
    { id: 24, name: "Property Paper Retrieval for Verification/inspection/For Lease Deed from Development Authority/Nagar Palika*", amount: "₹ 1,000" },
    { id: 25, name: "Property/Asset / Collateral Swapping Charges*", amount: "₹ 5000 Per Property" },
    { id: 26, name: "Cersai Charges**", amount: "₹ 300 Per Registration" },
    { id: 27, name: "Pre RCU/Risk Fi Charge*", amount: "₹ 1,200 Per Instance" },
    { id: 28, name: "ROC Filling Charges*", amount: "At Actuals" },
    { id: 29, name: "Progress Report / Subsequent Valuation Report*", amount: "₹ 1,500" },
    { id: 30, name: "EMI Delay Due to NACH Not Registered*", amount: "₹ 1000" },
    { id: 31, name: "Communication Charges*", amount: "₹ 200 Per Instance" },
    { id: 32, name: "Login Fee*", amount: "Upto ₹ 5000" },
    { id: 33, name: "FI Charges- Per Visit**# # (# (Pre / Post disbusement Visit including any third party)", amount: "₹ 1500" },
    { id: 34, name: "Agreement Re-Set Charges**# #", amount: "₹ 200" },
    { id: 35, name: "Loan Rescheduling Charges**# # #", amount: "₹ 5000" }
  ];

  return (
    <div style={styles.container}>
      <Navbar />
      
      {/* Header Section */}
      <div style={styles.header}>
        <h1 style={{ 
          margin: 0, 
          fontSize: '2.5rem',
          color: isDarkMode ? '#ffffff' : '#2c3e50'
        }}>
          SCHEDULE OF CHARGES
        </h1>
      </div>

      {/* Content Section */}
      <div style={styles.content}>
        <section style={styles.section}>
          <h1 style={styles.sectionTitle}>SCHEDULE OF CHARGES</h1>
          <div style={styles.version}>Version 2.0 (Dated 15th Oct 2025)</div>
          
          <div className="table-responsive">
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader} width="10%">S.No.</th>
                  <th style={styles.tableHeader} width="45%">Charge Name</th>
                  <th style={styles.tableHeader} width="45%">Kaa bill SOC</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr 
                    key={item.id}
                    style={{
                      ...styles.tableRow,
                      backgroundColor: isDarkMode ? '#2d2d2d' : '#ffffff',
                      ...(hoveredRow === index && {
                        backgroundColor: isDarkMode ? '#3a3a3a' : '#f5f5f5'
                      })
                    }}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td style={{
                      ...styles.tableCell, 
                      textAlign: 'center',
                      backgroundColor: isDarkMode ? 
                        (hoveredRow === index ? '#3a3a3a' : '#2d2d2d') : 
                        (hoveredRow === index ? '#f5f5f5' : '#ffffff'),
                      color: isDarkMode ? '#e0e0e0' : '#333'
                    }}>
                      {item.id}
                    </td>
                    <td style={{
                      ...styles.tableCell,
                      backgroundColor: isDarkMode ? 
                        (hoveredRow === index ? '#3a3a3a' : '#2d2d2d') : 
                        (hoveredRow === index ? '#f5f5f5' : '#ffffff'),
                      color: isDarkMode ? '#e0e0e0' : '#333'
                    }}>
                      {item.name}
                    </td>
                    <td 
                      style={{
                        ...styles.tableCell,
                        backgroundColor: isDarkMode ? 
                          (hoveredRow === index ? '#3a3a3a' : '#2d2d2d') : 
                          (hoveredRow === index ? '#f5f5f5' : '#ffffff'),
                        color: isDarkMode ? '#e0e0e0' : '#333'
                      }}
                      dangerouslySetInnerHTML={{ __html: item.amount }}
                    />
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={styles.disclaimer}>
              <p><strong style={styles.strong}>*</strong> GST and other government taxes applicable as per prevailing rate will be charged over and above the fees and charges.</p>
              <p><strong style={styles.strong}>**</strong> If stamp duty is purchased by NBFC on behalf of customer.</p>
              <p><strong style={styles.strong}>###</strong> FI Charges: in partnership and co-lending cases this will be applicable based on Term sheet.</p>
              <p>There are no RBI guidelines prescribing minimum/ maximum charges for asset customers. The regulator mentions that the NBFC should have transparency and accordingly disclose the charges prior to entering into agreement with the customer, prior intimation/ adequate disclosure before putting in place modifications.</p>
              <p><strong style={styles.strong}>###</strong> Agreement Re-Set Charges are applicable in the event of guarantor or any financial changes after e-signing of Agreement.</p>
              <p><strong style={styles.strong}>###</strong> Loan Rescheduling Charges are applicable if customer requesting the changes, no charges applicable if changes done for company's internal purposes.</p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  )
}

export default Schedule_of_charges